import type { InterfaceEntity } from '@unifyapps/defs/types/interface';
import type { ExecuteWorkflowNodeRequest } from '@unifyapps/network/generated/models/executeWorkflowNodeRequest';
import type { ExecuteWorkflowNodeResponse } from '@unifyapps/network/generated/models/executeWorkflowNodeResponse';
import { useCallback, useMemo } from 'react';

export function useOfflineDataSourceHandler(_: Record<string, unknown>) {
  const shouldUseOfflineMode = useMemo(() => {
    // always false for non native env
    return false;
  }, []);

  // offline query function
  const offlineQueryFunction = useCallback<
    (transformedPayload: ExecuteWorkflowNodeRequest) => Promise<ExecuteWorkflowNodeResponse>
  >(() => {
    return Promise.resolve({ id: '', response: {} });
  }, []);

  return {
    shouldUseOfflineMode,
    offlineQueryFunction,
    offlineConfig: {} as InterfaceEntity['properties']['offlineMode'],
  };
}
